import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const HeaderButton = ({ buttonText, idSection }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = () => {
        if (location.pathname !== '/') {
            // Guarda el id en localStorage para usarlo después de redirigir
            localStorage.setItem('scrollToId', idSection);
            navigate('/');
        } else {
            const section = document.getElementById(idSection);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="my-6 text-lg mt-8 font-lato bg-white text-black font-bold py-1 px-3 rounded-lg inline-flex items-center shadow-lg hover:shadow-xl transition-all hover:bg-idarkpink hover:text-white focus:outline-none focus:ring-4 focus:ring-pink-300 transform active:scale-95"
            onClick={handleClick}
        >
            {buttonText}
        </motion.button>
    );
};

export default HeaderButton;
